import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { TrackingProvider } from '@tradecafe/types/core'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { TrackingProvidersService } from 'src/pages/admin/settings/tracking-providers/tracking-providers.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createTrackingProvider, createTrackingProviderFailure, createTrackingProviderSuccess, deleteTrackingProvider, deleteTrackingProviderFailure, deleteTrackingProviderSuccess, loadTrackingProviders, loadTrackingProvidersFailure, loadTrackingProvidersSuccess, updateTrackingProvider, updateTrackingProviderFailure, updateTrackingProviderSuccess } from './tracking-provider.actions'

@Injectable()
export class TrackingProviderEffects {
  private actions$ = inject(Actions)
  private trackingProviders = inject(TrackingProvidersService)
  private toaster = inject(ToasterService)


  loadTrackingProviders$ = createEffect(() => this.actions$.pipe(
    ofType(loadTrackingProviders),
    switchMap(() =>
      from(this.trackingProviders.getTrackingProviders()).pipe(
        map(trackingProviders => loadTrackingProvidersSuccess({ trackingProviders })),
        catchAndLog(this.toaster, 'Unable to fetch tracking providers', loadTrackingProvidersFailure)))))

  createTrackingProvider$ = createEffect(() => this.actions$.pipe(
    ofType(createTrackingProvider),
    tap(() => this.toaster.progress('Saving tracking provider...')),
    switchMap(action =>
      from(this.trackingProviders.create(action.trackingProvider as Partial<TrackingProvider>)).pipe(
        map(trackingProvider => createTrackingProviderSuccess({ trackingProvider })),
        tap(() => this.toaster.success('Tracking provider saved successfully.')),
        catchAndLog(this.toaster, 'Unable to save tracking provider', createTrackingProviderFailure)))))

  updateTrackingProvider$ = createEffect(() => this.actions$.pipe(
    ofType(updateTrackingProvider),
    tap(() => this.toaster.progress('Saving tracking provider...')),
    switchMap(action =>
      from(this.trackingProviders.update({ ...action.trackingProvider, tracking_providers_id: action.id } as Partial<TrackingProvider>)).pipe(
        map(trackingProvider => updateTrackingProviderSuccess({ trackingProvider })),
        tap(() => this.toaster.success('Tracking provider saved successfully.')),
        catchAndLog(this.toaster, 'Unable to save tracking provider', updateTrackingProviderFailure)))))

  deleteTrackingProvider$ = createEffect(() => this.actions$.pipe(
    ofType(deleteTrackingProvider),
    tap(() => this.toaster.progress('Deleting tracking provider...')),
    switchMap(action =>
      from(this.trackingProviders.remove({ tracking_providers_id: action.id })).pipe(
        map(() => deleteTrackingProviderSuccess({ id: action.id })),
        tap(() => this.toaster.success('Tracking provider deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete tracking provider', deleteTrackingProviderFailure)))))
}
